import { getMapBy } from './getMapBy';

export const ROW_UNIQUE_KEY_NAME = '__key' as const;

export type UUIDType = ReturnType<Crypto['randomUUID']>;

export const objectWithRandomUniqueKey = <D>(data: D) => ({
  ...data,
  [ROW_UNIQUE_KEY_NAME]: window.crypto.randomUUID(),
});

export const objectWithoutRandomUniqueKey = <
  D extends { [ROW_UNIQUE_KEY_NAME]: UUIDType }
>({
  [ROW_UNIQUE_KEY_NAME]: _key,
  ...rest
}: D) => rest;

export const getMapByUniqueKey = <
  D extends { [ROW_UNIQUE_KEY_NAME]: UUIDType }
>(
  data: D[]
) => getMapBy(data, ROW_UNIQUE_KEY_NAME);
